var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hicon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3337 5.51514L9.73987 9.82768C8.31579 11.5366 7.60374 12.391 6.66699 12.391C5.73024 12.391 5.0182 11.5366 3.59411 9.82767L2.66699 8.71514",
    stroke: "#1877F2",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickBlue);
export default __webpack_public_path__ + "static/media/tick-blue.835246e312e12e51ec0a4159e33c0b40.svg";
export { ForwardRef as ReactComponent };